// Sort the reminder array by reminder_offset
function sortReminders (arr) {
  return arr
    .filter(item => item) // calling this will avoid the original array from being resorted
    .sort((a, b) => a.reminder_offset - b.reminder_offset)
}

/**
 * Standardised payload for creating reminder
 * Optionally pass in an existing array to automatically handle setting the default reminder_offset to increment
 * @param payload
 * @param existingReminders: array of elements to check over
 * @param defaultOffset: default offset to use if array is blank / not supplied
 * @param incrementOffset: incrementer amount for next reminder_offset (< 0 means decrement, >= 0 = increment)
 * @returns {{user_id: null, reminder_offset: (number|*|null), type: (string|*), value: null, client_id: null, key: null}}
 */
export function createReminder (payload, existingReminders = [], defaultOffset = 0, incrementOffset = 60) {
  if (!(payload.reminder_offset ?? null) && existingReminders.length > 0) {
    const sortedReminders = sortReminders(existingReminders)
    if (sortedReminders.length > 0) {
      const index = incrementOffset >= 0 ? sortedReminders.length - 1 : 0
      defaultOffset = (sortedReminders[index].reminder_offset ?? 0) + incrementOffset
    }
  }

  return {
    client_id: payload.client_id || null,
    user_id: payload.user_id || null,
    key: payload.key || null,
    type: payload.type || null,
    value: payload.value || null,
    reminder_offset: payload.reminder_offset ?? defaultOffset
  }
}

/**
 * Expand a client's preferred communication method into the concrete channels to use.
 * 'BOTH' -> ['EMAIL', 'SMS']; 'EMAIL'/'SMS'/null -> a single-element array.
 * Used so a reminder always carries a single channel type (EMAIL or SMS), never 'BOTH'.
 * @param type
 * @returns {string[]}
 */
export function expandReminderTypes (type) {
  return type === 'BOTH' ? ['EMAIL', 'SMS'] : [type]
}

export const COMMUNICATION_PROPS = {
  SMS: {
    label: 'SMS',
    value: 'SMS',
    icon: 'mdi-message-text',
    color: 'green'
  },
  EMAIL: {
    label: 'Email',
    value: 'EMAIL',
    icon: 'mdi-email',
    color: 'blue'
  },
  BOTH: {
    label: 'SMS & Email',
    value: 'BOTH',
    icon: 'mdi-message-badge-outline',
    color: 'purple'
  }
}

export default {
  methods: {
    // Pass includeBoth when selecting a client/company preference (which may be BOTH).
    // Per-reminder pickers must omit BOTH, since a reminder is always a single channel.
    baseGetCommunicationOptions (includeBoth = false) {
      const options = [
        COMMUNICATION_PROPS.SMS,
        COMMUNICATION_PROPS.EMAIL
      ]
      if (includeBoth) {
        options.push(COMMUNICATION_PROPS.BOTH)
      }
      return options
    },
    getFieldValue (type, key) {
      const val = COMMUNICATION_PROPS[type] || null
      return val ? (val[key] || null) : null
    }
  }
}
